module.exports = __webpack_public_path__ + "static/media/2021-october-youtube.2c5c6aa2.jpg";